import { render, staticRenderFns } from "./propertyFeeList.vue?vue&type=template&id=1bb1d5ea&scoped=true"
import script from "./propertyFeeList.vue?vue&type=script&lang=js"
export * from "./propertyFeeList.vue?vue&type=script&lang=js"
import style0 from "./propertyFeeList.vue?vue&type=style&index=0&id=1bb1d5ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1d5ea",
  null
  
)

export default component.exports